import React from 'react';
import { Box, Typography, Modal, Button } from '@mui/material';

const CustomModal = ({ isOpen, onClose, type, message }) => {
  // Define styles based on type
  const modalStyles = {
    Success: {
      bgcolor: '#e3f2fd', // Light blue background
      color: '#0d47a1', // Dark blue text
    },
    Warning: {
      bgcolor: '#fff3e0', // Light orange background
      color: '#e65100', // Dark orange text
    },
    Error: {
      bgcolor: '#ffebee', // Light red background
      color: '#b71c1c', // Dark red text
    },
  };

  const currentStyle = modalStyles[type] || modalStyles.Success; // Default to Success

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: currentStyle.bgcolor,
          color: currentStyle.color,
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2">
          {type}
        </Typography>
        <Typography id="modal-description" sx={{ mt: 2 }}>
          {message}
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 2, bgcolor: currentStyle.color, color: 'white' }}
          onClick={onClose}
          fullWidth
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default CustomModal;
